export default __webpack_public_path__ + "static/media/casaduana_ApartaLugar.2e888783.svg";